import { AppsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/appsEnum';

const VITE_CDN_URL = import.meta.env.VITE_CDN_URL;

const isDev = import.meta.env.VITE_APP_ENV !== 'production';

export const appConfig = {
  name: 'deepsearch',
  xEventEnabled: false,
  firebaseEventEnabled: false,
  supportMail: 'support@deepsearchai.co',
  billingMail: 'billing@deepsearchai.co',
  salesMail: 'sales@deepsearchai.co',
  stores: {
    appStore:
      'https://apps.apple.com/tr/app/deepsearch-ai-search-assistant/id6741062364',
    googlePlay:
      'https://play.google.com/store/apps/details?id=hubx.whois.ai.search',
  },
  cdnUrl: VITE_CDN_URL,
  analyticsApp: isDev ? AppsEnum.DEEPSEARCH_DEV : AppsEnum.DEEPSEARCH,
  featureFlags: {
    customEventPush: true,
  },
} as const;
